import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';

export default function AboutPage() {
  return (
    <div className="bg-white min-h-screen">
      {/* Hero */}
      <section className="pt-16 sm:pt-24 pb-10">
        <div className="mx-auto w-full max-w-3xl px-6 sm:px-10 text-center">
          <p className="text-[11px] uppercase tracking-[0.2em] text-gray-400 font-body font-medium">
            About
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-medium text-gray-900 mt-3">
            Prophet Malluc
          </h1>
        </div>
      </section>

      {/* Poster-style image following the aesthetic */}
      <section className="pb-10">
        <div className="mx-auto w-full max-w-2xl px-6 sm:px-10">
          <div className="bg-[#f5f0e8] p-6 sm:p-8">
            <h2
              className="text-center font-body font-light text-2xl sm:text-3xl lg:text-4xl text-gray-900 mb-6 sm:mb-8"
              style={{ letterSpacing: '0.35em' }}
            >
              PROPHET MALLUC
            </h2>
            <div className="relative overflow-hidden mx-auto max-w-lg">
              <img
                src="https://customer-assets.emergentagent.com/job_prophecy-live/artifacts/3tyagrnu_IMG_8976.JPG"
                alt="Prophet Malluc"
                className="w-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Bio Content */}
      <section className="pb-20 sm:pb-28">
        <div className="mx-auto w-full max-w-2xl px-6 sm:px-10">
          <div className="space-y-6 text-base text-gray-600 font-body leading-8">
            <p>
              Born in Abidjan, Ivory Coast, Prophet Malluc M. Elias discovered his supernatural gifts at an early age. He soon realized these gifts were more than mere abilities; they ignited a profound desire within him to do God's work.
            </p>
            <p>
              At 17, the Lord appeared to him, revealing the great work ahead. Upon turning 18, God instructed him to move to Dallas, Texas, to begin his ministry. Later, one night, the Lord visited him again, instructing him to move to New Jersey and wait for the next season that God had prepared. In obedience, he moved and sought the Lord diligently.
            </p>
            <p>
              A couple of years later, an angel of the Lord appeared to him in a vision. The angel showed him a great revival that would begin with him in his homeland, Ivory Coast. In 2019, following the Lord's instructions, he moved back to Ivory Coast and founded the "Deeper Generation" &mdash; Revival Movement. This movement sparked a spiritual awakening across the country, establishing Prophet Malluc as one of the most influential young figures in Ivory Coast.
            </p>
            <p>
              In 2023, God directed him to initiate Nights of Revival in New Jersey and New York City, focusing on revelatory teaching, prophecy, deliverance, healing, and the manifestation of miracles, signs, and wonders. This transformative mission continues to impact hundreds each week at Revival Culture and thousands via live stream through Prophet Malluc Ministries.
            </p>
            <p>
              Prophet Malluc holds weekly programs designed to encourage spiritual growth and equip believers to walk in the fullness of God. He is passionate about leadership, discipleship, and empowering others to fulfill their divine purpose worldwide.
            </p>
          </div>

          <div className="mt-12 text-center">
            <Link to="/revival-night">
              <Button className="h-12 px-8 rounded-sm bg-[#1a2e4a] text-white font-body text-sm font-medium hover:bg-[#0f1b2d] transition-colors tracking-wider uppercase">
                View Upcoming Events
                <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
